import { Injectable } from '@angular/core';
import {
    SessionServiceProxy,
    UserLoginInfoDto,
    ApplicationInfoDto,
    GetCurrentLoginInformationsOutput,
} from '../../../shared/service-proxies/service-proxies';
import { GoogleAnalyticsService } from '../../../app/shared/common/analytics/google-analytics.service';
import { identifyPostHogUser } from '@shared/analytics/posthog';

@Injectable()
export class AppSessionService {
    private _user: UserLoginInfoDto;
    private _application: ApplicationInfoDto;

    constructor(private _sessionService: SessionServiceProxy, public googleAnalyticsService: GoogleAnalyticsService) {}

    get application(): ApplicationInfoDto {
        return this._application;
    }

    get user(): UserLoginInfoDto {
        return this._user;
    }

    get userId(): number {
        return this.user ? this.user.id : null;
    }

    /**
     * Returns True if the User is considered an Internal User, False otherwise
     */
    get isInternalUser(): boolean {
        return !!this._user && !this._user.partnerId && !this._user.providerId;
    }

    init(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this._sessionService
                .getCurrentLoginInformations()
                .toPromise()
                .then(
                    (result: GetCurrentLoginInformationsOutput) => {
                        this._application = result.application;
                        this._user = result.user;
                        this.sendUserInfoEvent(this._user);
                        resolve(true);
                    },
                    (err) => {
                        reject(err);
                    }
                );
        });
    }

    private sendUserInfoEvent(user: UserLoginInfoDto): void {
        if (user && user.uuid) {
            this.googleAnalyticsService.eventEmitter('AppSmartOffice', 'User UUID', user.uuid);
        }
        if (user && user.uuid) {
            identifyPostHogUser(user.uuid);
        }
    }
}
